import { makeImmutable } from "../../core/makeImmutable";
export class OrderLineReference {
    constructor(params) {
        this.orderLineIndex = params.orderLineIndex;
        this.productInstanceIndex = params.productInstanceIndex;
        this.productInstance = params.productInstance;
        makeImmutable(this);
    }
    eq(other) {
        return (this.orderLineIndex === other.orderLineIndex &&
            this.productInstanceIndex === other.productInstanceIndex &&
            this.productInstance.id.eq(other.productInstance.id));
    }
    get checkoutData() {
        return {
            productGroupIndex: this.orderLineIndex,
            productSequenceNum: this.productInstanceIndex,
        };
    }
    get price() {
        return this.productInstance.price;
    }
}
